import {
  DocumentTextIcon,
  ListBulletIcon,
  HeartIcon,
  CubeIcon,
  BuildingOfficeIcon,
  PresentationChartBarIcon,
  BeakerIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';

export type ReportType =
  | 'bird-certificate'
  | 'birds-listing'
  | 'breeding-list'
  | 'mutation-inventory'
  | 'breeding-outcomes'
  | 'balance-sheet'
  | 'income-statement'
  | 'inventory';

export interface ReportOption {
  id: ReportType;
  name: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  category: 'operational' | 'financial';
}

export const reportOptions: ReportOption[] = [
  {
    id: 'bird-certificate',
    name: 'Bird Certificate',
    description: 'Official certificate for individual birds with lineage and breeding details',
    icon: DocumentTextIcon,
    category: 'operational',
  },
  {
    id: 'birds-listing',
    name: 'Birds Listing',
    description: 'Comprehensive list of all birds with their details and current status',
    icon: ListBulletIcon,
    category: 'operational',
  },
  {
    id: 'breeding-list',
    name: 'Breeding Records',
    description: 'Complete breeding pairs list with clutch history and success rates',
    icon: HeartIcon,
    category: 'operational',
  },
  {
    id: 'mutation-inventory',
    name: 'Mutation Inventory',
    description: 'Structured genotype counts by locus — visual, split, and carrier birds per species',
    icon: BeakerIcon,
    category: 'operational',
  },
  {
    id: 'breeding-outcomes',
    name: 'Breeding Genetics Outcomes',
    description: 'Hatch-time predictions compared to actual banded phenotypes',
    icon: ChartBarIcon,
    category: 'operational',
  },
  {
    id: 'inventory',
    name: 'Inventory Report',
    description: 'Current stock levels and inventory valuation by category',
    icon: CubeIcon,
    category: 'operational',
  },
  {
    id: 'balance-sheet',
    name: 'Balance Sheet',
    description: 'Financial position statement showing assets, liabilities, and equity',
    icon: BuildingOfficeIcon,
    category: 'financial',
  },
  {
    id: 'income-statement',
    name: 'Income Statement',
    description: 'Profit and loss statement for the specified period',
    icon: PresentationChartBarIcon,
    category: 'financial',
  },
];
